<template>
  <div>
    <div class="ibox-title">Placed links</div>
    <div class="ibox-content">
      <div class="row">
        <div class="col-md-12">
          <table class="table small m-b-xs table-hover" v-if="placements">
            <thead>
            <tr>
              <th>Placed</th>
              <th>Site</th>
              <th>Anchor</th>
              <th>Link</th>
              <th>Post title</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="placement in placements" v-bind:key="placement.id">
              <td>{{ !placement.fulfilledTime || $moment(placement.fulfilledTime.date).calendar() }}</td>
              <td>{{ !placement.fulfilledPosr || placement.fulfilledPost.site.url }}</td>
              <td>{{ placement.search }}</td>
              <td>{{ placement.link }}</td>
              <td><a :href="!placement.fulfilledPost || placement.link" target="_blank" rel="noreferrer">{{ !placement.fulfilledPost || placement.fulfilledPost.title }}</a></td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Placements',
  props: ['placements'],
  data () {
    return {}
  },
  mounted () {
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pages/Client/Placements.vue